import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          That’s why Intel helped create The N50 Project, a cross-industry collaboration tasked with
          enabling the next 50% of the global population to participate in the digital world. Today,
          the N50 Project counts approximately 100 total member companies, with Geeks Without
          Frontiers acting as the project’s program management office. “We currently have more than
          40 projects in the pipeline globally,” Gutwein says, “with the potential to impact around
          a quarter of a million people.”
        </p>
      </section>
    </>
  );
}

export default Chapter4;
